import React, {useCallback, useEffect, useState} from 'react'
import {useCognitoAuth} from '../auth/core/CognitoAuth'
import {resolveSmsMfaEnabled} from '../auth/core/resolveSmsMfaStatus'
import {MfaSmsSettingsModal} from './MfaSmsSettingsModal'

/**
 * SMS MFA status + manage modal (Settings page /admin).
 */
export const SmsMfaAccountRow: React.FC = () => {
  const {cognitoAuth} = useCognitoAuth()
  const [mfaModalOpen, setMfaModalOpen] = useState(false)
  const [smsMfaEnabled, setSmsMfaEnabled] = useState<boolean | null>(null)

  const refreshMfaStatus = useCallback(() => {
    if (!cognitoAuth) {
      setSmsMfaEnabled(null)
      return
    }
    void resolveSmsMfaEnabled(cognitoAuth)
      .then(setSmsMfaEnabled)
      .catch(() => setSmsMfaEnabled(null))
  }, [cognitoAuth])

  useEffect(() => {
    refreshMfaStatus()
  }, [refreshMfaStatus])

  return (
    <>
      <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed p-6 mb-5'>
        <i className='fas fa-shield-halved text-primary fs-2x me-4' />
        <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
          <div className='mb-3 mb-md-0 fw-bold'>
            <h4 className='text-gray-800 fw-bolder'>SMS two-factor authentication</h4>
            <div className='fs-6 text-gray-600 pe-7'>
              Optional SMS verification when you sign in with email and password. When enabled, you
              enter a code from SMS after your password.
            </div>
            {smsMfaEnabled !== null && cognitoAuth && (
              <div className='fs-7 mt-2'>
                <span className='badge bg-light text-gray-800 me-2'>SMS 2FA</span>
                {smsMfaEnabled ? (
                  <span className='text-success'>On</span>
                ) : (
                  <span className='text-muted'>Off</span>
                )}
              </div>
            )}
          </div>
          <button
            type='button'
            className='btn btn-primary align-self-center text-nowrap'
            disabled={!cognitoAuth}
            onClick={() => setMfaModalOpen(true)}
          >
            {smsMfaEnabled ? 'Manage' : 'Enable'}
          </button>
        </div>
      </div>
      <MfaSmsSettingsModal
        show={mfaModalOpen}
        onHide={() => setMfaModalOpen(false)}
        onStatusChanged={refreshMfaStatus}
      />
    </>
  )
}
